import { LinkInterface } from "@/interface/nav.interface";
import { LinksConstrains } from "@/enums/links.enum";

let links: Array<LinkInterface> = [
  {
    title: "menu.catalog",
    icon: "catalog",
    href: LinksConstrains.CATALOG,
    name: "catalog",
    children: [
      {
        title: "menu.items",
        href: LinksConstrains.CATALOG_CATEGORIES,
        parent: "catalog",
      },
      {
        title: "menu.modifiers_list",
        href: LinksConstrains.CATALOG_MODIFIERS_LIST,
        parent: "catalog",
      },
      {
        title: "menu.recipes_book",
        href: LinksConstrains.CATALOG_RECIPES_BOOK,
        parent: "catalog",
      },
    ],
  },
  {
    title: "menu.customers",
    icon: "customers",
    href: LinksConstrains.CUSTOMERS,
  },
  {
    title: "menu.orders",
    icon: "orders",
    href: LinksConstrains.ORDERS,
  },
  {
    title: "menu.settings",
    icon: "settings",
    href: LinksConstrains.SETTINGS,
    name: "settings",
    children: [
      {
        title: "menu.account_settings",
        href: LinksConstrains.SETTINGS_ACCOUNT_SETTINGS,
        parent: "settings",
      },
      {
        title: "menu.business_settings",
        href: LinksConstrains.SETTINGS_BUSINESS_DETAILS,
        parent: "settings",
      },
      {
        title: "menu.cash_and_payment",
        href: LinksConstrains.SETTINGS_CASH_AND_PAYMENT_TAXES,
        parent: "settings",
      },
    ],
  },
];

export default links;
